module.exports = __webpack_public_path__ + "static/media/bottle.36bbdcf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bottle.png
// module id = 713
// module chunks = 0